import React from 'react'
import Header from '../component/layout/Header'
import Footer from '../component/layout/Footer'
import UserOrder from "../component/User/UserOrder/UserOrder.jsx"
const UserOrderPage = () => {
  React.useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top when the page loads
  }, []);
  return (
    <>
    <Header/>
    <UserOrder/>
    <Footer/>
    </>
  )
}

export default UserOrderPage